module.exports = __webpack_public_path__ + "57d549b956f84a099c6eea5fad64928a.svg";